export const tableChromeHeight = 250

export const RULE_TYPES = {
  title: 'Title',
  url: 'URL',
}
